enum FrictionRegion {
	None = 0,
	Nordic = 1,
	European = 2,
}

export default FrictionRegion

